// tabs/FacilityInvoicesParentTab.js - Updated to pass onRefreshFacilityInvoices prop
import React from "react";
import FacilitiesTab from "./FacilitiesTab";

function FacilityInvoicesParentTab({
  facilityInvoices,
  facilities,
  facilityUnits,
  loading,
  onViewInvoice,
  onGenerateInvoice,
  onRefreshFacilityInvoices,
  getFacilityInvoiceSummary,
  searchTerm,
  onSearch,
}) {
  return (
    <div>
      <FacilitiesTab
        facilities={facilities}
        facilityUnits={facilityUnits}
        facilityInvoices={facilityInvoices}
        loading={loading}
        onGenerateInvoice={onGenerateInvoice}
        onViewInvoice={onViewInvoice}
        onRefreshFacilityInvoices={onRefreshFacilityInvoices}
        searchTerm={searchTerm}
        onSearch={onSearch}
      />
    </div>
  );
}

export default FacilityInvoicesParentTab;
